module.exports = __webpack_public_path__ + "static/media/incoming.c9df923e.svg";